import * as React from 'react';
import { TileViewProps } from 'ui/tile-view';
import { AddDocumentItemOptions, DeleteDocumentItemOptions } from 'app/infrastructure/ui/form/types';
import { ConnectCaseSelector } from 'app/area/case/components/connected-cases/connect-case-selector';
import { TileView } from 'ui';
import { ConnectedCaseActionTypes } from 'app/components/connect-existing-cases/connect-existing-cases';

export interface ConnectedCasesTileViewProps extends TileViewProps {
  entityId: number;
  caseId: number;
  connectionTypeId: number;
  maxSequence: number;
  stateForCaseIds: {[caseId: string]: { valid: boolean; fetching: boolean }};
  validateCaseId: (caseId: number) => void;
  onAddDocumentItem: (selectAddedItem?: boolean, options?: AddDocumentItemOptions) => void;
  onDeleteDocumentItem: (selectParentItem: boolean, options?: DeleteDocumentItemOptions) => void;
  createSearchForCasesToConnect: (draftId: number, connectionTypeId: number) => Promise<number>;
  allowConnectCases: boolean;
  allowDisconnectCases: boolean;
  textAddExisting: string;
  textAddNew: string;
  textNoConnectionToItself: string;
  textConnect: string;
  textDisconnect: string;
  placeholderSearch: string;
  titleSearch: string;
  textInvalidRangeError: string;
  connectedDrafts?: any[];
  favouriteComponent: React.ComponentType<any>;
  onChangeDraftConnections?: (params: {
    connectionTypeId: number; 
    connectedCaseId: number;
    type: ConnectedCaseActionTypes;
  }) => void;
  changingDraftConnection?: boolean;
}

export class ConnectedCasesTileView extends React.PureComponent<ConnectedCasesTileViewProps, {}> {

  public static defaultProps: Partial<ConnectedCasesTileViewProps> = {
    allowConnectCases: false,
    allowDisconnectCases: false
  };

  private createSearchForCasesToConnect = (): Promise<number> => {
    return this.props.createSearchForCasesToConnect(this.props.entityId, this.props.connectionTypeId);
  };

  private handleDraftConnection = (
    selectAddedItem: boolean,
    documentItemOptions: AddDocumentItemOptions | DeleteDocumentItemOptions,
    actionType: ConnectedCaseActionTypes
  ) => {
    this.props.onChangeDraftConnections({
      connectedCaseId: documentItemOptions.childId,
      connectionTypeId: this.props.connectionTypeId,
      type: actionType
    });
  };

  private handleDraftConnect = (selectAddedItem: boolean, documentItemOptions: AddDocumentItemOptions) => {
    this.handleDraftConnection(selectAddedItem, documentItemOptions, ConnectedCaseActionTypes.CONNECT);
  };

  private handleDraftDisconnect = (selectAddedItem: boolean, documentItemOptions: DeleteDocumentItemOptions) => {
    this.handleDraftConnection(selectAddedItem, documentItemOptions, ConnectedCaseActionTypes.DISCONNECT);
  };
  public render() {
    const {
      connectionTypeId,
      allowConnectCases
    } = this.props;

    const required = this.props.label && this.props.label.required;

    const addButton = !!allowConnectCases &&
      <ConnectCaseSelector {
        ...{
          ...this.props, required, children: undefined,
          connectionTypeId,
          createSearchForCasesToConnect: this.createSearchForCasesToConnect,
          onAddDocumentItem: this.handleDraftConnect,
          onDeleteDocumentItem: this.handleDraftDisconnect,
          disableButton: this.props.changingDraftConnection
        }}
      />;

    return (
      <TileView {...{...this.props, readOnly: !allowConnectCases, addButton}} />
    );
  }
}

// eslint:disable: max-line-length no-console
export const ConnectedCasesTileViewEdit = (props: any) => <ConnectedCasesTileView allowConnectCases={!props.readOnly} allowDisconnectCases={!props.readOnly} {...props} />;
